/**
 * Smile App Translation - Advanced Method
 *
 * This script tries multiple approaches to ensure translations work:
 * 1. Direct DOM manipulation with retry mechanism
 * 2. MutationObserver for dynamic content
 * 3. Content script approach for potential iframe content
 *
 * How to implement:
 * 1. Go to your Shopify admin panel
 * 2. Navigate to: Online Store > Themes > Current theme > Actions > Edit code
 * 3. Scroll down to the "Assets" folder and click on it
 * 4. Click on "Add a new asset" and name it "smile-advanced-translator.js"
 * 5. Paste this code and save
 * 6. Open your theme.liquid file and add this line before the closing </body> tag:
 *    {{ 'smile-advanced-translator.js' | asset_url | script_tag }}
 */

(function () {
  // Debug flag - set to false to disable all logging
  const DEBUG_MODE = false;

  // Console logging with prefix for easy debugging
  function log(message) {
    if (DEBUG_MODE) {
      console.log(`🌷 Smile Translator: ${message}`);
    }
  }

  // Translations dictionary
  const translations = {
 'Ways to earn': 'Manieren om te verdienen',
    'Ways to redeem': 'Manieren om in te wisselen',
    'Sign in': 'Inloggen',
    'Join now': 'Nu aanmelden',
    'Create my account': 'Maak mijn account aan',
    'Already have an account?': 'Heb je al een account?',
    'Refer friends': 'Vrienden doorverwijzen',
    'Earn points': 'Verdien punten',
    'Redeem': 'Inwisselen',
    'My points': 'Mijn panterpunten',
    'Available points': 'Beschikbare panterpunten',
    'Get started': 'Aan de slag',
    'View activity': 'Bekijk activiteit',
    'Learn more': 'Meer informatie',
    'Rewards': 'Beloningen',
    'Balance': 'Saldo',
    'Shop': 'Winkel',
    'Free': 'Gratis',
    'Settings': 'Instellingen',
    'Log out': 'Uitloggen',
    'Log in': 'Inloggen',
    'Register': 'Registreren',
    'Save': 'Opslaan',
    'Cancel': 'Annuleren',
    'Submit': 'Versturen',
    'Email': 'E-mail',
    'Password': 'Wachtwoord',
    'Continue': 'Doorgaan',
    'Expiration date': 'Vervaldatum',
    'Panter Punten for every €1 spent': 'Panterpunten voor elke €1',
    'Edit Date': 'Datum wijzigen',
    'Your rewards': 'Jouw beloningen',
    'You have': 'Je hebt',
    'rewards available': 'beloningen beschikbaar',
    'Your activity': 'Jouw activiteit',
    'Like on Facebook': 'Like op Facebook',
    'Spent': 'Besteed',
    'Free': 'Gratis',
    'Free Gift PanterStore labello coupon': 'Gratis cadeau panterstore labello coupon.',
    'Reward can only be used on ': 'Beloning kan alleen worden gebruikt voor ',
    'Add product to cart': 'Product toevoegen aan winkelwagen',
  };

  // Add custom instructions for multiple rewards
  function addRewardInstructions(element) {
    const instructionMap = [
      {
        match: 'Gratis JOLIE TOP',
        className: 'jolietop-instructions',
        html: 'Kopieer de kortingscode hieronder en plak deze tijdens het afrekenen in het veld <b>Kortingscode</b>.',
      },
      {
        match: 'Gratis Gift PanterStore labello coupon',
        className: 'labello-instructions',
        html: 'Kopieer de kortingscode hieronder en plak deze tijdens het afrekenen in het veld <b>Kortingscode</b>.',
      },
      {
        match: 'Gratis cadeau panterstore labello coupon',
        className: 'labello-instructions',
        html: 'Kopieer de kortingscode hieronder en plak deze tijdens het afrekenen in het veld <b>Kortingscode</b>.',
      },
    ];
    element.querySelectorAll(".card-description").forEach((desc) => {
      instructionMap.forEach(({ match, className, html }) => {
        if (
          desc.textContent.includes(match) &&
          !desc.querySelector("." + className)
        ) {
          const instr = document.createElement("div");
          instr.className = className;
          instr.innerHTML = html;
          instr.style.color = "#777";
          instr.style.marginTop = "4px";
          instr.style.display = "block";
          desc.appendChild(instr);
        }
      });
    });
  }

  // Function to directly replace text in DOM nodes
  function translateTextNode(node) {
    const text = node.nodeValue.trim();
    Object.keys(translations).forEach((key) => {
      if (node.nodeValue.includes(key)) {
        node.nodeValue = node.nodeValue.replace(
          new RegExp(key, "g"),
          translations[key]
        );
        log(`Translated "${key}" to "${translations[key]}"`);
      }
    });
  }

  // Deep DOM text replacement
  function translateElementContent(element) {
    if (element.tagName === "SCRIPT" || element.tagName === "STYLE") {
      return;
    }

    // Process text nodes
    const walker = document.createTreeWalker(
      element,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );
    let node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.trim() === "") continue;
      translateTextNode(node);
    }

    // Process elements with specific attributes (like aria-label)
    const allElements = element.querySelectorAll("*");
    allElements.forEach((el) => {
      if (el.hasAttribute("aria-label")) {
        const ariaText = el.getAttribute("aria-label");
        Object.keys(translations).forEach((key) => {
          if (ariaText.includes(key)) {
            el.setAttribute(
              "aria-label",
              ariaText.replace(new RegExp(key, "g"), translations[key])
            );
          }
        });
      }
      if (el.hasAttribute("placeholder")) {
        const placeholderText = el.getAttribute("placeholder");
        Object.keys(translations).forEach((key) => {
          if (placeholderText.includes(key)) {
            el.setAttribute(
              "placeholder",
              placeholderText.replace(new RegExp(key, "g"), translations[key])
            );
          }
        });
      }
    });

    // Specific handling for list item titles
    const listItemTitles = element.querySelectorAll(".list-item-title");
    listItemTitles.forEach((item) => {
      const text = item.textContent.trim();
      if (translations[text]) {
        item.textContent = translations[text];
        log(
          `Directly translated list item: "${text}" to "${translations[text]}"`
        );
      }
    });

    // Specific handling for links with exact text
    const links = element.querySelectorAll("a");
    links.forEach((link) => {
      const text = link.textContent.trim();
      if (translations[text]) {
        link.textContent = translations[text];
        log(`Directly translated link: "${text}" to "${translations[text]}"`);
      }
    });

    // Inject custom instructions at the end
    addRewardInstructions(element);
  }

  // Main function to find and translate the Smile widget
  function translateSmileWidget() {
    log("Looking for Smile widget content...");
    const smileContainer = document.getElementById("SmileUIPanelContainer");
    if (smileContainer) {
      log("Found Smile container by ID");
      translateElementContent(smileContainer);
      return true;
    }
    const possibleContainers = document.querySelectorAll(
      ".frame-root, .panel-wrapper, .main-panel-container"
    );
    if (possibleContainers.length > 0) {
      log(
        `Found ${possibleContainers.length} possible Smile containers by class`
      );
      possibleContainers.forEach((container) => {
        translateElementContent(container);
      });
      return true;
    }
    const listItemTitles = document.querySelectorAll(".list-item-title");
    if (listItemTitles.length > 0) {
      log(`Found ${listItemTitles.length} list-item-title elements`);
      listItemTitles.forEach((item) => {
        const text = item.textContent.trim();
        if (translations[text]) {
          item.textContent = translations[text];
          log(`Translated list item: "${text}" to "${translations[text]}"`);
        }
      });
      return true;
    }
    log("No Smile widget content found yet");
    return false;
  }

  // Check for iframes that might contain the Smile widget
  function checkIframes() {
    try {
      const iframes = document.querySelectorAll("iframe");
      log(`Checking ${iframes.length} iframes for Smile content`);
      iframes.forEach((iframe, index) => {
        try {
          const iframeDoc =
            iframe.contentDocument || iframe.contentWindow.document;
          log(`Successfully accessed iframe #${index}`);
          const smileElements = iframeDoc.querySelectorAll(
            "#SmileUIPanelContainer, .list-item-title"
          );
          if (smileElements.length > 0) {
            log(`Found Smile elements in iframe #${index}`);
            translateElementContent(iframeDoc.body);
          }
        } catch (err) {
          log(`Cannot access iframe #${index} content - likely cross-origin`);
        }
      });
    } catch (err) {
      log(`Error checking iframes: ${err.message}`);
    }
  }

  // Inject a script into accessible iframes to translate and add instructions
  function injectIframeContentScript() {
    const iframes = Array.from(document.querySelectorAll("iframe"));
    iframes.forEach((iframe, index) => {
      try {
        const iframeDoc =
          iframe.contentDocument || iframe.contentWindow.document;
        const script = iframeDoc.createElement("script");
        script.textContent = `
          (function() {
            const translations = {
              'Ways to earn': 'Manieren om te verdienen',
              'Ways to redeem': 'Manieren om in te wisselen',
              'Sign in': 'Inloggen',
              'Free Gift PanterStore labello coupon': 'Gratis cadeau panterstore labello coupon'
            };
            function addRewardInstructions(element) {
              const instructionMap = [
                {
                   match: 'Gratis JOLIE TOP',
                  className: 'jolietop-instructions',
                  html: 'Kopieer de kortingscode hieronder en plak deze tijdens het afrekenen in het veld <b>Kortingscode</b>.',
                },
                {
                     match: 'Gratis Gift PanterStore labello coupon',
    className: 'labello-instructions',
    html: 'Kopieer de kortingscode hieronder en plak deze tijdens het afrekenen in het veld <b>Kortingscode</b>.',
                },
       {
    match: 'Gratis cadeau panterstore labello coupon',
    className: 'labello-instructions',
    html: 'Kopieer de kortingscode hieronder en plak deze tijdens het afrekenen in het veld <b>Kortingscode</b>.In ',
  }           
              ];
              element.querySelectorAll('.card-description').forEach(desc => {
                instructionMap.forEach(({ match, className, html }) => {
                  if (
                    desc.textContent.includes(match) &&
                    !desc.querySelector('.' + className)
                  ) {
                    const instr = document.createElement('div');
                    instr.className = className;
                    instr.innerHTML = html;
                    instr.style.color = '#777';
                    instr.style.marginTop = '4px';
                    instr.style.display = 'block';
                    desc.appendChild(instr);
                  }
                });
              });
            }
            function translateElements() {
              document.querySelectorAll('.list-item-title').forEach(elem => {
                const text = elem.textContent.trim();
                if (translations[text]) {
                  elem.textContent = translations[text];
                  console.log('Iframe translation applied: ' + text);
                }
              });
              document.querySelectorAll('a').forEach(link => {
                const text = link.textContent.trim();
                if (translations[text]) {
                  link.textContent = translations[text];
                }
              });
              // Custom instructions for rewards
              addRewardInstructions(document);
            }
            translateElements();
            const observer = new MutationObserver(function() {
              translateElements();
            });
            observer.observe(document.body, {
              childList: true,
              subtree: true
            });
            setTimeout(() => observer.disconnect(), 15000);
          })();
        `;
        iframeDoc.head.appendChild(script);
        log(`Injected translation script into iframe #${index}`);
      } catch (err) {
        log(`Couldn't inject script into iframe #${index}: ${err.message}`);
      }
    });
  }

  // Initialize translation process when content is loaded
  function initTranslation() {
    log("Translation process starting");
    if (translateSmileWidget()) {
      log("Initial translation successful");
    } else {
      log("Initial translation unsuccessful, setting up retries and observers");
    }
    checkIframes();
    injectIframeContentScript();

    // Set up periodic checks for dynamic content
    const checkInterval = setInterval(function () {
      translateSmileWidget();
      checkIframes();
    }, 1000);
    setTimeout(function () {
      clearInterval(checkInterval);
      log("Stopping periodic checks after timeout");
    }, 15000);

    // Set up a MutationObserver to watch for dynamic content changes
    const observer = new MutationObserver(function (mutations) {
      const significant = mutations.some(
        (mutation) =>
          mutation.addedNodes.length > 0 &&
          Array.from(mutation.addedNodes).some(
            (node) =>
              node.nodeType === 1 &&
              (node.id === "SmileUIPanelContainer" ||
                (node.classList &&
                  (node.classList.contains("frame-root") ||
                    node.classList.contains("panel-wrapper") ||
                    node.classList.contains("list-item-title") ||
                    node.classList.contains("card-description"))))
          )
      );
      if (significant) {
        log("Significant DOM changes detected, retranslating");
        translateSmileWidget();
        checkIframes();
      }
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
    setTimeout(function () {
      observer.disconnect();
      log("Disconnected mutation observer after timeout");
    }, 15000);

    // Handle clicks that might load new content
    document.addEventListener("click", function (event) {
      setTimeout(function () {
        translateSmileWidget();
        checkIframes();
      }, 500);
    });
  }

  // Start the process once the DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initTranslation);
  } else {
    initTranslation();
  }
  window.addEventListener("load", function () {
    log("Window fully loaded, running translation again");
    translateSmileWidget();
    checkIframes();
  });
})();
